import React from "react";
import "./ourproductsection.css";
import { MdArrowOutward } from "react-icons/md";
import { useNavigate } from "react-router-dom";


const OurProductSection = () =>{
    const navigate = useNavigate();

    const navigateToSignUp = () =>{
        navigate("/login?fromSignup=true")
    }


    const productInfo = [
        {
            title: "Stock API",
            description: "Stock Archives API provides key endpoint of historic for information in an easy to api",
            subtitle: "CPI, Recession Indicators, follow an etf"
        }/*,{
            title:"Stock Dashboard",
            description: "Stock archives stock dash research dashboard allow you to customize your research experience with customizable data widget, deep research, and customer insight.",
            subtitle: "Cusomizable Dashboard, More indepth data points, customer insight"
        }*/
    ]
    return(
        <div className="product-item-section">
            {productInfo.map((item,index) =>(
                <div className="product-item-container">
                    <div className="product-info-container">
                        <p><strong>{index+1}. {item.title}</strong></p>
                        <p>{item.description}</p>
                        <p>{item.subtitle}</p>
                    </div>
                    <div className="product-button-container">
                        <button onClick={navigateToSignUp} className="product-button" type="button"><MdArrowOutward className="product-button-logo" /></button>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default OurProductSection;